// Import dependencies
import { builderFetch } from '@builder/core/utilities';
import { html } from 'lit';
const { confirm, isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.itemLoop.deleteLoop;

/**
 * Deeltes a loop from the current recipe
 *
 * @param {Number} loopID The loop ID (post ID)
 * @return {Promise} The apiFetch promise
 */
const deleteLoop = async ( loopID ) => {
	// Get the loop
	const loop = UncannyAutomator._core.recipe.item.loop.getLoop( loopID );

	// If the item is not define, stop here
	if ( isEmpty( loop ) ) {
		throw new Error( `deleteLoop: The loop ${ loopID } doesn't exist` );
	}

	/**
	 * Checks if an array of items have at least one enabled item inside
	 *
	 * @param {Array} items An array of items
	 * @return {Boolean} Whether it has at least one live item
	 */
	const itemsHaveLiveItem = items => items.some(
		item => item.items ? itemsHaveLiveItem( item.items ) : item.is_item_on
	);

	// Check if the recipe is live and there is at least one live item, and show a warning message
	if (
		// Check if the recipe is live
		UncannyAutomator._recipe.is_recipe_on &&
		// Check if the loop contains live items
		itemsHaveLiveItem( loop.items )
	) {
		await confirm( {
			content: html`
				<uo-alert type="warning">
					${ strings.warningMessage }
				</uo-alert>
			`,
			confirmButtonLabel: strings.deleteLoop
		} );
	} else {
		await confirm( {
			content: strings.irreversibleAction,
			confirmButtonLabel: strings.deleteLoop
		} );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'delete_loop_block',
			// eslint-disable-next-line camelcase
			loop_id: loopID
		},
		snackbar: {
			loading: strings.deletingLoop,
			success: strings.loopDeleted,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/loop/delete-loop', {
				detail: {
					loopID: loopID
				}
			} ) );
		}

		return response;
	} );
}

export default deleteLoop;
